import { render, staticRenderFns } from "./WechartUserModal.vue?vue&type=template&id=aae30a4a&scoped=true&"
import script from "./WechartUserModal.vue?vue&type=script&lang=js&"
export * from "./WechartUserModal.vue?vue&type=script&lang=js&"
import style0 from "./WechartUserModal.vue?vue&type=style&index=0&id=aae30a4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae30a4a",
  null
  
)

export default component.exports